import React, {useState} from 'react';
import {Avatar, IconButton, Modal, Toolbar, Typography} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Profile from './Profile';
import {styled} from '@mui/material/styles';

// Styled toolbar to match the overall theme of the app
const StyledToolbar = styled(Toolbar)(({theme}) => ({
    backgroundColor: 'rgb(23 20 33)', // Match with the dark purple/blue background
    borderBottom: '1px solid rgba(255, 255, 255, 0.12)', // Subtle border for a clean separation
    color: 'white', // White text/icons for visibility
    display: 'flex',
    justifyContent: 'space-between', // Space between profile and title
    padding: '0 16px',
}));

// Styled avatar to match the overall color scheme
const StyledAvatar = styled(Avatar)(({theme}) => ({
    backgroundColor: '#282C34', // Slightly dark background for the avatar
    color: '#4d8484', // Neon-like color for the Account icon if no image
}));

const Header = ({user, setUser}) => {
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const handleProfileModalOpen = () => setIsProfileModalOpen(true);
    const handleProfileModalClose = () => setIsProfileModalOpen(false);

    return (
        <StyledToolbar>
            {/* Title of the page */}
            <Typography variant="h6" sx={{fontWeight: 'bold', color: 'white'}}>
                {user.displayName ? `שלום, ${user.displayName}` : 'Lifshits AI'}
            </Typography>

            {/* User Profile Avatar */}
            <IconButton onClick={handleProfileModalOpen}>
                <StyledAvatar alt={user?.displayName} src={user?.photoURL || ''}>
                    {!user?.photoURL && <AccountCircleIcon fontSize="large"/>} {/* Default icon if no image */}
                </StyledAvatar>
            </IconButton>

            {/* Profile modal */}
            <Modal
                open={isProfileModalOpen}
                onClose={handleProfileModalClose}
                aria-labelledby="profile-modal-title"
                aria-describedby="profile-modal-description"
            >
                <Profile
                    setUser={setUser}
                    isOpen={isProfileModalOpen}
                    handleClose={handleProfileModalClose}
                />
            </Modal>
        </StyledToolbar>
    );
};

export default Header;
